import React from 'react';
import { businessInfo } from '../mockData';

export const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "name": businessInfo.name,
    "image": "https://roof-quotes.preview.emergentagent.com/logo.png",
    "telephone": businessInfo.phone,
    "email": businessInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": businessInfo.address.street,
      "addressLocality": businessInfo.address.suburb,
      "addressRegion": businessInfo.address.state,
      "postalCode": businessInfo.address.postcode,
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-33.9167",
      "longitude": "150.8547"
    },
    "url": "https://roof-quotes.preview.emergentagent.com",
    "priceRange": "$$",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "-33.9167",
        "longitude": "150.8547"
      },
      "geoRadius": "50000"
    },
    "serviceType": [
      "Metal Roof Installation",
      "Roof Repairs",
      "Roof Replacement",
      "Roof Maintenance",
      "Gutter Installation",
      "Emergency Roofing Services"
    ],
    "description": "Professional metal roofing services in Greater Sydney. Expert installation, repair, and replacement services. 24/7 emergency service available.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Roofing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Metal Roof Installation",
            "description": "Professional installation of premium metal roofing systems"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Roof Repairs",
            "description": "Fast and reliable roof repair services for all metal roofing types"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Complete Roof Replacement",
            "description": "Full roof replacement services with premium materials"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Roof Maintenance",
            "description": "Regular maintenance programs to extend roof lifespan"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "50"
    }
  };

  // Safe to use dangerouslySetInnerHTML here because:
  // 1. structuredData is a hardcoded object defined entirely in this component
  // 2. No user input is incorporated into the data
  // 3. JSON.stringify escapes any special characters
  // 4. This is the standard approach for JSON-LD structured data in React
  const safeJsonLd = JSON.stringify(structuredData);
  
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLd }}
    />
  );
};
